import { useTranslation } from "react-i18next";
import { formatNumber } from "utils/utils";
import {
  TipNoWorkers,
  TipWorkerAvatar,
  TipWorkerCell,
  TipWorkerHeader,
  TipWorkerMissingText,
  TipWorkerNameCell,
  TipWorkerNameText,
  TipWorkerPaymentText,
  TipWorkerRow,
} from "../tips.styled";
import {
  formatWorkerTime,
  getPaymentLabel,
  getWorkerInitials,
  getWorkerName,
} from "./tips.rows.logic";
import type { TipWorkersPanelContentProps } from "./tips.rows.types";

export const TipWorkersPanelContent = (
  props: TipWorkersPanelContentProps,
): JSX.Element => {
  const { t } = useTranslation();

  if (props.workers.length === 0) {
    return <TipNoWorkers>{t("Tips.NoWorkers")}</TipNoWorkers>;
  }

  return (
    <>
      <TipWorkerHeader>
        <div>{t("Tips.Workers")}</div>
        <div>{t("Tips.Team")}</div>
        <div>{t("Tips.Hours")}</div>
        <div>{t("Tips.WorkerTips")}</div>
        <div>{t("Tips.Payment")}</div>
      </TipWorkerHeader>
      {props.workers.map((worker) => (
        <TipWorkerRow key={worker.workerId}>
          <TipWorkerNameCell>
            <TipWorkerAvatar>{getWorkerInitials(worker)}</TipWorkerAvatar>
            <TipWorkerNameText>{getWorkerName(worker)}</TipWorkerNameText>
          </TipWorkerNameCell>
          <TipWorkerCell>
            {worker.workGroupName ?? t("Tips.NotChosen")}
          </TipWorkerCell>
          <TipWorkerCell>
            {worker.approvedTimeReportCount <= 0 ? (
              <TipWorkerMissingText>
                {t("Tips.TimeReportMissing")}
              </TipWorkerMissingText>
            ) : (
              formatWorkerTime({
                hourLabel: t("General.HourShortened"),
                minuteLabel: t("General.MinutesShortened"),
                worker,
              })
            )}
          </TipWorkerCell>
          <TipWorkerCell>
            {formatNumber(worker.tipAmount)} {t("Tips.Currency")}
          </TipWorkerCell>
          <TipWorkerPaymentText>
            {getPaymentLabel({
              fallbackStatus: props.rowPaymentStatus,
              status: worker.status,
              t,
            })}
          </TipWorkerPaymentText>
        </TipWorkerRow>
      ))}
    </>
  );
};
